<template>
  <div class="text-xs-center">
    <v-layout row justify-center>
      <v-snackbar v-model="values.dialog" :color="values.color || 'info'" :timeout="values.timeout || 3000" centered bottom>
        {{ values.text || ''}}
        <v-layout row justify-end>
          <v-btn dark :color="values.buttonColor" @click="values.buttonFunction()">
            {{values.buttonText}}
          </v-btn>
          <v-btn dark flat @click="$store.commit('snackbarButton/change_values', {dialog: false})">
            <v-icon>{{this.translate('system.button.close.icon')}}</v-icon>
          </v-btn>
        </v-layout>
      </v-snackbar>
    </v-layout>
  </div>

</template>

<script>
  export default {
    name: 'snackbarButton',
    computed: {
      values () {
        return this.$store.getters[`snackbarButton/values`] || ''
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/PSnackbarButton.vue